import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20flowing%20curves%20in%20orange%20and%20coral%20tones%2C%20gentle%20light%20beams%2C%20minimalist%20modern%20aesthetic%2C%20clean%20atmosphere%2C%20digital%20navigation%20concept%2C%20soft%20texture%2C%20artistic%20composition%2C%20warm%20inviting%20feeling%2C%20subtle%20geometric%20patterns%2C%20ethereal%20glow&width=1600&height=900&seq=hero-bg-2026-aiqingdao&orientation=landscape"
          alt="爱情岛路线导航背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-sm text-background-50/90 font-medium">持续更新 · 最新路线可用</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-6">
            爱情岛一论坛
            <br />
            <span className="text-primary-300">免费路线访问指南</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            整理最新可用免费路线入口、访问方法及使用技巧，帮助用户快速稳定访问爱情岛一论坛，
            无需付费，操作简单，持续更新最新线路，收藏备用不迷路。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/latest-routes"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-road-map-line text-lg"></i>
              查看最新路线
            </Link>
            <Link
              to="/category/access-tutorials"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-base hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line text-lg"></i>
              访问教程
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 mt-12 pt-8 border-t border-background-50/15">
            {[
              { value: '12+', label: '篇教程文章' },
              { value: '4', label: '大分类导航' },
              { value: '99%', label: '路线可用率' },
              { value: '日更', label: '路线更新频率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}